import { useEffect, useMemo, useRef } from "react";
import debounce from "lodash/debounce";

export const useDebounceFunction = <T extends (...args: any[]) => any>(
	fn: T,
	delay: number
) => {
	const fnRef = useRef(fn);

	// always keep latest function (prevents stale closures)
	useEffect(() => {
		fnRef.current = fn;
	}, [fn]);

	const debounced = useMemo(() => {
		return debounce((...args: Parameters<T>) => {
			fnRef.current(...args);
		}, delay);
	}, [delay]);

	// cleanup on unmount
	useEffect(() => {
		return () => {
			debounced.cancel();
		};
	}, [debounced]);

	return debounced;
};
